declare global {
	interface Window {
		gtag?: (...args: any[]) => void;
		gtag_report_conversion?: (url?: string) => boolean;
	}
}

// Google转化追踪配置
const GOOGLE_ADS_ID = 'AW-17228899494';

// 根据语言选择转化标签
const getConversionLabel = (locale: string) => {
	// ja 或 hant 时使用 rlBWCJr_9eAaEKbJsJdA
	// en 时使用 0eCbCK6H9uAaEKbJsJdA
	return locale === 'en' ? 
		'0eCbCK6H9uAaEKbJsJdA' : 
		'rlBWCJr_9eAaEKbJsJdA';
};

/**
 * 初始化Google转化追踪函数
 * @param locale 当前语言环境
 */
export const initGoogleConversion = (locale: string) => {
	if (typeof window !== "undefined" && !window.gtag_report_conversion) {
		window.gtag_report_conversion = function(url?: string) {
			const callback = function () {
				if (typeof url != 'undefined') {
					window.location = url as any;
				}
			};
			if (window.gtag) {
				const conversionLabel = getConversionLabel(locale);
				window.gtag('event', 'conversion', {
					'send_to': `${GOOGLE_ADS_ID}/${conversionLabel}`,
					'event_callback': callback
				});
			}
			return false;
		};
	}
};

/**
 * 触发Google转化追踪
 * @param locale 当前语言环境
 * @param url 可选的重定向URL
 * @param eventName 可选的事件名称，用于调试
 */
export const reportGoogleConversion = (locale: string, url?: string, eventName?: string) => {
	// 初始化转化追踪函数
	initGoogleConversion(locale);
	
	// 触发转化追踪
	if (typeof window !== "undefined" && window.gtag_report_conversion) {
		console.log(`触发Google转化追踪 (${locale}): ${eventName || '未命名事件'}`);
		return window.gtag_report_conversion(url);
	}
	
	console.warn('Google转化追踪未初始化');
	return false;
};

/**
 * 直接使用gtag触发自定义转化事件
 * @param locale 当前语言环境
 * @param eventName 事件名称
 * @param parameters 事件参数
 */
export const reportCustomConversion = (locale: string, eventName: string, parameters?: Record<string, any>) => {
	if (typeof window !== "undefined" && window.gtag) {
		const conversionLabel = getConversionLabel(locale);
		window.gtag('event', eventName, {
			'send_to': `${GOOGLE_ADS_ID}/${conversionLabel}`,
			...parameters
		});
		console.log(`触发自定义转化事件 (${locale}): ${eventName}`, parameters);
	} else {
		console.warn('Google gtag未初始化');
	}
}; 